/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { START_RESOURCE_META_DATA_MODAL } from 'state/action-types';

import { createReducer } from 'state/utils';

export const resourceConnectId = createReducer(null, {
    [START_RESOURCE_META_DATA_MODAL]: (state, { payload }) => payload.resourceConnectId,
});

export default combineReducers({
    resourceConnectId,
});
